import React from "react";

import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import { StyledWhy } from "./styles";
import messages from "./messages";

const Why = () => (
    <StyledWhy>
        <h2>
            <FormattedMessage {...messages.h2} />
        </h2>
        <p>
            <FormattedHTMLMessage {...messages.p} />
        </p>
    </StyledWhy>
);

export default Why;
